import { mapGetters } from 'vuex';
import { AuthGetterTypes, ProjectContextGetters } from '../store/getters';
import permissionCheckService from '../services/permissionCheckService';

export default {
	computed: {
		...mapGetters({
			permissions: [AuthGetterTypes.PERMISSIONS],
			currentUser: [AuthGetterTypes.CURRENT_USER],
			selectedProject: [ProjectContextGetters.SELECTED_PROJECT],
			superAdmin: [AuthGetterTypes.IS_SUPERADMIN],
		}),
	},
	methods: {
		/**
		 * Send array if you want to check multiple permissions
		 * @param permissions {string | array}
		 * @return {boolean}
		 */
		hasPermissions(permissionsToCheck) {
			if (this.superAdmin) return true;
			if (!this.selectedProject) return false;
			if (!this.permissions) return false;
			if (this.permissions.length <= 0) return false;
			return permissionCheckService.hasPermissions(
				this.permissions,
				permissionsToCheck
			);
		},

		//hasPermissions([PermissionEnum.Tools.FormBuilder.View,PermissionEnum.Tools.FormBuilder.ADD])
	},
};
